export default {
  siteTitle: "CAL Talent Assessment Platform",
  myAssessment: "My Assessment",
  logout: "Logout",
  changePW: "Change Password",
  search: "Search",
  clear: "Clear",
  assessment: "Admin/Assessment",
  SigningIn: "Logging in...",
  loggingOut: "Logging out...",
  notFound: "404: Not Found",
  notFoundMsg: "You just hit a route that doesn't exist.",
  admin: "Admin",
  action: "Action",
  delete: "Delete",
  create: "Create",
  alias: "Alias",
  upload: "Upload",
  download: "Download",
  sp: " ",
  question_categories: "Question Categories",
  question_relationships: "Question Relationships",
  question_choices: "Question Choices",
  question_choicelists: "Question Choice Lists",
  questions: "Questions",
  name: "Name",
  remarks: "Remarks",
  home: "Home",
  content: "Content",
  templates: "Templates",
  desc: "Descriptions",
  forms: "Forms",
  form_questions: "Form Questions",
  welcome: "Welcome",
  // BillingCourseSummaryNavigationTitle: "Course Billing Summary",
  // BillingCourseSummaryTableHeaderCourse: "Course",
  // BillingCourseSummaryTableHeaderParentGroup: "Parent Group",
  // BillingCourseSummaryTableHeaderGroup: "Group",
  // BillingCourseSummaryTableHeaderTotalCourse: "Total Course",
  // BillingCourseSummaryTableHeaderCompletedCourse: "Completed Course",
  // BillingCourseSummaryTableHeaderActivateAccounts: "Activate Accounts",
  // BillingCourseSummaryTableHeaderDeactivateAccounts: "Deactivate Accounts",
  // BillingCourseSummaryTableHeaderTotalAccounts: "Total Accounts",
  // BillingCourseSummaryTableHeaderAction: "Action",
  // BillingCourseSummaryFilterLabelClientGroup: "Client Group",
  // BillingCourseSummaryFilterLabelCourse: "Course",
  // BillingCourseSummaryFilterLabelHasCompletedCourse: "Has Completed Course",
  // BillingCourseSummaryFilterLabelUserAddedDate: "User Added Date",
  // BillingCourseSummaryFilterLabelCourseStartTimeDate: "Course Start Time Date",
  // BillingCourseSummaryFilterLabelCourseEndTimeDate: "Course End Time Date",
  // BillingCourseSummaryFormCoursePlaceholder: "Select course",
  // BillingCourseSummaryModalExportTableTitle: "Export Course Billing Summary",
  // BillingCourseDetailTableHeaderLoginID: "Login ID",
  // BillingCourseDetailTableHeaderFullName: "Full Name",
  // BillingCourseDetailTableHeaderEmail: "Email",
  // BillingCourseDetailTableHeaderCourseProgress: "Course Progress",
  // BillingCourseDetailTableHeaderUserAddedTime: "User Added Time",
  // BillingCourseDetailTableHeaderCourseStartTime: "Course Start Time",
  // BillingCourseDetailTableHeaderCourseEndTime: "Course End Time",
  // BillingCourseDetailTableHeaderLoginTimeCount: "Number of Login Times",
  // BillingCourseDetailFilterLabeluserAddedDate: "User Added Date",
  // BillingCourseDetailFilterLabelCourseStartDate: "Course Start Date",
  // BillingCourseDetailFilterLabelCourseEndDate: "Course End Date",
  // BillingCourseDetailFilterLabelCompletedCourse: "Has Completed Course",
  // BillingCourseDetailModalExportTableTitle: "Export Course Billing Detail",
  UploadFileSizeCannotExceed15MB: "File size cannot exceed 15MB!",
  ClientUserCourseStatusPassedWithoutCertificateMessage:
    "Congratulations on completing the course.",
  IntegrationPageTitle: "Client Integration",
  IntegrationNavigationButton: "Integration",
  IntegrationTabCredentials: "Credentials",
  IntegrationTabWebhookSubscriptions: "Webhook Subscriptions",
  IntegrationTabDeliveryHistory: "Delivery History",
  IntegrationCredentialTableName: "Name",
  IntegrationCredentialTableClientId: "Client ID",
  IntegrationCredentialTableStatus: "Status",
  IntegrationCredentialTableCreatedOn: "Created On",
  IntegrationCredentialTableLastUsed: "Last Used",
  IntegrationCredentialTableActions: "Actions",
  IntegrationCredentialCreateButton: "Create New",
  IntegrationToggleGroupReportScoreJsonButtonYes: "Get Group Report Json: Allow",
  IntegrationToggleGroupReportScoreJsonButtonNo: "Get Group Report Json: Not Allow",
  IntegrationCredentialRotateButton: "Rotate",
  IntegrationCredentialRevokeButton: "Revoke",
  IntegrationCredentialCreateModalTitle: "Create Credential",
  IntegrationCredentialNameLabel: "Credential Name",
  IntegrationCredentialNamePlaceholder: "Enter credential name",
  IntegrationCredentialFilterStatus: "Filter by Status",
  IntegrationCredentialFilterName: "Search by name",
  IntegrationCredentialScopesLabel: "Allowed Scopes",
  IntegrationSecretWarning: "Save your credentials now. The client secret will not be shown again.",
  IntegrationSecretClientId: "Client ID",
  IntegrationSecretClientSecret: "Client Secret",
  IntegrationSecretSigningSecret: "Signing Secret",
  IntegrationSecretCopyButton: "Copy",
  IntegrationSecretDoneButton: "I've saved it",
  IntegrationRevokeConfirm: "Are you sure you want to revoke this credential?",
  IntegrationRotateConfirm: "Are you sure you want to rotate the secret?",
  IntegrationSubscriptionTableName: "Name",
  IntegrationSubscriptionTableEndpoint: "Endpoint URL",
  IntegrationSubscriptionTableStatus: "Status",
  IntegrationSubscriptionTableActions: "Actions",
  IntegrationSubscriptionCreateButton: "Create New",
  IntegrationSubscriptionEditButton: "Edit",
  IntegrationSubscriptionActivateButton: "Activate",
  IntegrationSubscriptionDeactivateButton: "Deactivate",
  IntegrationSubscriptionRotateSecretButton: "Rotate Secret",
  IntegrationSubscriptionCreateModalTitle: "Create Webhook Subscription",
  IntegrationSubscriptionEditModalTitle: "Edit Webhook Subscription",
  IntegrationSubscriptionNameLabel: "Name",
  IntegrationSubscriptionNamePlaceholder: "Enter subscription name",
  IntegrationSubscriptionFilterStatus: "Filter by Status",
  IntegrationSubscriptionFilterSearch: "Search by webhook name or endpoint URL",
  IntegrationSubscriptionEndpointLabel: "Endpoint URL",
  IntegrationSubscriptionEndpointPlaceholder: "https://your-endpoint.example.com/webhook",
  IntegrationSubscriptionIsActiveLabel: "Active",
  IntegrationSubscriptionActivateConfirm: "Are you sure you want to activate this subscription?",
  IntegrationSubscriptionDeactivateConfirm: "Are you sure you want to deactivate this subscription?",
  IntegrationSubscriptionRotateConfirm: "Are you sure you want to rotate the signing secret?",
  IntegrationDeliveryTableEventId: "Event ID",
  IntegrationDeliveryTableEventType: "Event Type",
  IntegrationDeliveryTableStatus: "Status",
  IntegrationDeliveryTableResponseCode: "Response Code",
  IntegrationDeliveryTableNextRetry: "Next Retry",
  IntegrationDeliveryTableAttempts: "Attempts",
  IntegrationDeliveryTableActions: "Actions",
  IntegrationDeliveryRetryButton: "Retry Now",
  IntegrationDeliveryRetryConfirm: "Are you sure you want to retry this delivery?",
  IntegrationDeliveryFilterStatus: "Filter by Status",
  IntegrationDeliveryFilterEventType: "Filter by Event Type",
  IntegrationDeliveryFilterEventId: "Search by Event ID",
  IntegrationDeliveryDrawerTitle: "Delivery Detail",
  IntegrationDeliveryDrawerErrorMessage: "Error Message",
  IntegrationDeliveryDrawerResponseSnippet: "Response Body Snippet",
  IntegrationDeliveryDrawerPayload: "Payload JSON",
  IntegrationStatusActive: "Active",
  IntegrationStatusInactive: "Inactive",
  IntegrationStatusRevoked: "Revoked",
  IntegrationStatusExpired: "Expired",
  IntegrationStatusSucceeded: "Succeeded",
  IntegrationStatusRetryPending: "Retry Pending",
  IntegrationStatusPermanentlyFailed: "Permanently Failed",
  IntegrationStatusInFlight: "In Flight",
  IntegrationStatusPending: "Pending",
  IntegrationClientLabel: "Client",
  IntegrationButtonCancel: "Cancel",
  IntegrationButtonConfirm: "Confirm",
  IntegrationBackToClientGroups: "Back to Client Groups",
  IntegrationButtonSubmit: "Submit",
  IntegrationButtonUpdate: "Update",
  "Admin.ClientGroups.IntegrationButton": "Integration",
  "Admin.ClientGroups.Integration.PageTitle": "ClientGroup Integration",
};
